import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TokenServiceService {

  constructor(
    private http: HttpClient
  ) { }

  setToken(token: string): boolean {
    try {
      return true;
    } catch {
      return false;
    }
  }

  getToken(): string {
    try {
      const tokenString: string = localStorage.getItem('token');
      return tokenString;
    } catch {
      return null;
    }
  }

  clearToken(): boolean {
    try {
      localStorage.removeItem('token');
      return true;
    } catch {
      return false;
    }
  }

  decodeToken(token: string): Observable<any> {
    return this.http.post<any>('/api/tokenHandler/decodeToken', { token })
      .pipe(
      catchError(this.handleError<any>('decodeToken'))
      );
  }

  private handleError<T>(operator = 'operation', result?: T) {
    return (error: any) => {
      console.error(error);
      return of(result as T);
    };
  }
}
